module.exports = __webpack_public_path__ + "img/l_Kotlin.ef9fc28b.svg";